import './App.css';
import Contact from './Portfolio/Contact';
import Intro from './Portfolio/Intro';
import Project from './Portfolio/Project';
import Stack from './Portfolio/Stack';
import './css/intro.scss'
import './css/stack.scss'
import './css/contact.scss'
import './css/project.scss'
function App() {
  return (
    <div className="App">

      <Intro></Intro>
      <Stack></Stack>
      <Project></Project>
      <Contact></Contact>
    </div>
  );
}

export default App;
